import FormattedMessage from 'I18n/components/FormattedMessage';
import PortalIdParser from 'PortalIdParser';
import { isUsedInEmbedDashboardInfo, isUsedInRecurringEmail } from 'dashboard-lib/public/dashboard-used-in/useGetDashboardUsedIn';
import { Link } from 'foundations-components/transitional/components/Link';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EmbedDashboardLocationCopy = ({
  location
}) => {
  if (location === 'analyze-tab') {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "embedDashboard.locations.analyze-tabs"
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "embedDashboard.locations.workspace"
  });
};
const getRecurringEmailLink = dashboardId => {
  return `/reports-dashboard/${PortalIdParser.get()}/view${dashboardId}?showRecurringEmails=true`;
};
export const UsedInList = ({
  usedInData
}) => {
  const recurringEmailUsedInData = usedInData.filter(isUsedInRecurringEmail);
  const embedDashboardUsedInData = usedInData.filter(isUsedInEmbedDashboardInfo);
  return /*#__PURE__*/_jsxs(List, {
    marginBlockStart: "200",
    children: [embedDashboardUsedInData.map(usedIn => /*#__PURE__*/_jsx(ListItem, {
      children: /*#__PURE__*/_jsxs(Link, {
        external: true,
        href: usedIn.data.link,
        children: [usedIn.data.name, "\xA0", /*#__PURE__*/_jsx(EmbedDashboardLocationCopy, {
          location: usedIn.data.location
        })]
      })
    }, usedIn.data.embedDashboardAppId)), recurringEmailUsedInData.map(usedIn => /*#__PURE__*/_jsx(ListItem, {
      children: /*#__PURE__*/_jsx(Link, {
        external: true,
        href: getRecurringEmailLink(usedIn.data.objectId),
        children: usedIn.data.nickname || usedIn.data.subject
      })
    }, usedIn.data.id))]
  });
};